import moment from "moment";

export function scheduleRange(mode, anchor) {
    const date = moment(anchor);
    if (!date.isValid()) throw new Error("A valid schedule date is required");
    const unit = mode === "month" ? "month" : mode === "week" ? "isoWeek" : "day";
    return { startDate: date.clone().startOf(unit), endDate: date.clone().endOf(unit) };
}

export function navigateScheduleDate(mode, anchor, direction) {
    const date = moment(anchor).clone();
    // Use the first day when paging months to avoid January 31 -> February -> March 28.
    if (mode === "month") date.startOf("month");
    return date.add(direction, mode === "month" ? "month" : mode === "week" ? "week" : "day");
}

export function customRangeError(start, end) {
    if (!start || !end || !moment(start).isValid() || !moment(end).isValid())
        return "Choose both a From date and a To date.";
    if (moment(start).startOf("day").isAfter(moment(end).startOf("day")))
        return "The To date must be on or after the From date.";
    return "";
}